import { apiResource } from '@/util/resources'

export default {
  state: {
    debtor: {},
    showPaymentPlanCreatedDialog: false,
    hasActiveConversation: null,
    lastUnseenAnsweredMessage: null
  },
  actions: {
    addDebtorContact ({ commit }, payload) {
      commit('clearError')
      var shouldShowMessage = !payload.Silent
      return apiResource.post('api/debtor/add/' + payload.ContactType, payload).then((response) => {
        commit('addDebtorContact', payload)
        if (shouldShowMessage && payload.ContactType === 'phone') {
          commit('setMessage', { type: 'primary', text: 'Puhelinnumero lisätty onnistuneesti' })
        }
        if (shouldShowMessage && payload.ContactType === 'email') {
          commit('setMessage', { type: 'primary', text: 'Sähköpostiosoite lisätty onnistuneesti' })
        }
      }).catch((errorResponse) => {
        commit('setError', errorResponse)
        throw errorResponse
      })
    },
    allowContact ({ commit }, payload) {
      commit('clearError')
      apiResource.post('api/debtor/allow/' + payload.ContactType + '/' + payload.Allow).then((response) => {
        // TODO
      }).catch((errorResponse) => {
        commit('setError', errorResponse)
      })
    },
    addIbanInfo ({ commit }, payload) {
      commit('clearError')
      apiResource.post('api/debtor/updateIban', payload).then((response) => {
        if (response.data.status === 0) {
          if (response.data.responseObject === true) {
            commit('ibanAdded')
            commit('setMessage', { type: 'primary', text: 'ibanAddedSuccesfully', translate: true })
          } else {
            commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
          }
        } else {
          commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
        }
      }).catch((errorResponse) => {
        commit('setMessage', { type: 'error', text: errorResponse.data.errorCode, translate: true })
      })
    }
  },
  mutations: {
    setDebtor (state, payload) {
      state.debtor = payload
      state.hasActiveConversation = payload.hasActiveConversation || false
      state.lastUnseenAnsweredMessage = payload.lastUnseenAnsweredMessage || null
    },
    ibanAdded (state) {
      state.debtor.hasOverpayment = false
    },
    addDebtorContact (state, payload) {
      switch (payload.ContactType) {
        case 'phone': {
          state.debtor.contactInformation.phones.unshift({
            landCode: null,
            smsAllowed: payload.Allow,
            type: 0,
            number: '+358' + payload.Text
          })
          break
        }
        case 'email': {
          state.debtor.contactInformation.emails.unshift({
            emailAddress: payload.Text,
            emailAllowed: payload.Allow
          })
          break
        }
        default: {
          // TODO: error handling
          break
        }
      }
    },
    logoutDebtor (state) {
      state.debtor = {}
      state.hasActiveConversation = null
      state.lastUnseenAnsweredMessage = null
    },
    setShowPaymentPlanCreatedDialog (state, payload) {
      state.showPaymentPlanCreatedDialog = payload
    },
    clearLastUnseenAnsweredMessage (state) {
      state.lastUnseenAnsweredMessage = null
    },
    setLastUnseenAnsweredMessage (state, payload) {
      state.lastUnseenAnsweredMessage = payload || null
    },
    setHasActiveConversation (state, val) {
      state.hasActiveConversation = val
    }
  },
  getters: {
    debtor (state) {
      return state.debtor
    },
    hasActiveConversation (state) {
      return state.hasActiveConversation
    },
    lastUnseenAnsweredMessage (state) {
      return state.lastUnseenAnsweredMessage
    },
    isCompany (state) {
      return state.debtor.isCompany
    },
    hasUPIOrders (state) {
      return state.debtor.hasUPIOrders
    },
    showPaymentPlanCreatedDialog (state) {
      return state.showPaymentPlanCreatedDialog
    }
  }
}
